import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface CustomDimensionTagProps {
  className?: string;
}

/** Marks a dimension that comes from an organization's custom attribute. */
export const CustomDimensionTag = ({ className }: CustomDimensionTagProps) => {
  const { t } = useTranslation('authenticated.reports');

  return (
    <span
      className={cn(
        'shrink-0 rounded bg-violet-500/10 px-1.5 py-px text-[10.5px] font-medium leading-4 text-violet-700 dark:bg-violet-400/15 dark:text-violet-300',
        className
      )}
    >
      {t('dimensionPicker.custom')}
    </span>
  );
};
